/* ============================================================
   MYPI — PRODUCT SCRIPT (Shopify port of the reference product.js)
   Variant engine (swatches + selects → real variants), gallery,
   sticky add-to-bag bar, complete-look variant selects and the
   "You May Also Like" recommendations fetch.
   Personalisation is owned entirely by the Zepto app block —
   this file renders no personalisation UI. Add-to-bag itself is
   delegated globally by mypi-theme.js (js-add-to-bag / the
   js-mypi-product-form submit).
   ============================================================ */
(function () {
  'use strict';
  var $ = window.MYPI.$, $$ = window.MYPI.$$, money = window.MYPI.money;

  /* ---------- gallery: scroll-snap track ----------
     Every image is a slide in .mypi-gallery__track, so swiping is native
     scrolling (it follows the finger, no wait for a download). The slides mirror
     the thumbs: same order, same hidden state. */
  function galleryTrack() { return $('#galleryMain .mypi-gallery__track'); }

  function visibleSlides() {
    var track = galleryTrack();
    return track ? $$('.mypi-gallery__slide', track).filter(function (s) { return !s.hidden; }) : [];
  }

  function currentSlideIndex() {
    var track = galleryTrack();
    if (!track || !track.clientWidth) return 0;
    var i = Math.round(track.scrollLeft / track.clientWidth);
    return Math.max(0, Math.min(i, visibleSlides().length - 1));
  }

  // Active thumb + dot follow whichever slide is in view.
  function markActive(index) {
    var slide = visibleSlides()[index];
    if (!slide) return;
    var id = slide.dataset.mediaId;
    $$('.mypi-thumb').forEach(function (t) {
      t.classList.toggle('is-active', t.dataset.mediaId === id);
    });
    $$('#galleryMain .mypi-gallery__dot').forEach(function (d, i) {
      d.classList.toggle('is-active', i === index);
    });
  }

  function renderDots() {
    var wrap = $('#galleryMain .mypi-gallery__dots');
    if (!wrap) return;
    var count = visibleSlides().length;
    wrap.innerHTML = count > 1 ? new Array(count + 1).join('<span class="mypi-gallery__dot"></span>') : '';
    markActive(currentSlideIndex());
  }

  // Start downloading the images on show so the next swipe never waits. Lazy
  // images inside a horizontal scroller otherwise only load once they are
  // scrolled into view — which is exactly the swipe.
  function warmSlides() {
    visibleSlides().forEach(function (s) {
      var img = $('img', s);
      if (img && img.loading === 'lazy') img.loading = 'eager';
    });
  }

  function goToSlide(index, smooth) {
    var track = galleryTrack();
    if (!track) return;
    track.scrollTo({ left: index * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
    markActive(index);
    $('#galleryMain').classList.remove('is-zoomed');
  }

  // Show the slide for mediaId. A variant image outside the current group is
  // brought into it (slide + thumb) rather than silently ignored.
  function goToMedia(mediaId, smooth) {
    var track = galleryTrack();
    var slide = track && $('.mypi-gallery__slide[data-media-id="' + mediaId + '"]', track);
    if (!slide) return false;
    if (slide.hidden) {
      slide.hidden = false;
      var thumb = $('.mypi-thumb[data-media-id="' + mediaId + '"]');
      if (thumb) thumb.hidden = false;
      renderDots();
    }
    goToSlide(visibleSlides().indexOf(slide), smooth);
    return true;
  }

  // After the colour filter hides/shows thumbs, the slides follow.
  function syncSlidesToThumbs() {
    var track = galleryTrack();
    if (!track) return;
    $$('.mypi-thumb').forEach(function (t) {
      var slide = $('.mypi-gallery__slide[data-media-id="' + t.dataset.mediaId + '"]', track);
      if (slide) slide.hidden = t.hidden;
    });
    renderDots();
    warmSlides();
  }

  /* ---------- gallery: main image swap ---------- */
  function swapMain(src, alt, mediaId, smooth) {
    if (mediaId != null && goToMedia(String(mediaId), smooth)) return;
    // Fallback for a gallery without the track (single-image markup).
    var main = $('#galleryMain');
    if (!main || !src) return;
    var img = $('img', main);
    if (!img) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = src;
    if (alt != null) img.alt = alt;
    if (mediaId != null) {
      $$('.mypi-thumb').forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.mediaId === String(mediaId));
      });
    }
  }

  /* ---------- colour: gallery group, title, URL ----------
     Images are grouped by colour through their ALT TEXT, the convention this
     store already uses (the live theme's custom.use_variants_image_group reads
     the same field). Matching is loose in both directions so option "Navy" still
     finds images alt-tagged "Navy Blue".
     ------------------------------------------------------ */
  function colourKey(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  // Each thumb carries data-colour = its alt text + its filename, lowercased. A
  // colour matches when that haystack contains the whole colour name.
  function mediaMatchesColour(key, colour) {
    var k = colourKey(key), c = colourKey(colour);
    if (!k || !c) return false;
    return k.indexOf(c) !== -1;
  }

  // Fallback for names that only partly appear, e.g. option "Baby Pink" against a
  // file called pink-case.jpg. Uses the colour's longest word so "Baby Pink" tries
  // "pink" rather than "baby", and never a word short enough to hit by accident.
  function mediaMatchesColourWord(key, colour) {
    var k = colourKey(key);
    var words = colourKey(colour).split(/[^a-z0-9]+/).filter(function (w) { return w.length >= 4; });
    if (!k || !words.length) return false;
    words.sort(function (a, b) { return b.length - a.length; });
    return k.indexOf(words[0]) !== -1;
  }

  function colourToHandle(colour) {
    return colourKey(colour).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  // How many of a colour's images to show — the section's "Images shown per
  // colour" setting, mirrored onto the thumb strip so Liquid and JS agree.
  function imagesPerColour() {
    var strip = $('.mypi-gallery__thumbs');
    var n = strip ? parseInt(strip.dataset.imagesPerColour, 10) : NaN;
    return n > 0 ? n : 4;
  }

  // Show only the chosen colour's images, capped at that count, and move the main
  // image to the first of them. A colour with no tagged images falls back to the
  // full gallery rather than emptying it.
  function filterGalleryByColour(colour) {
    var thumbs = $$('.mypi-thumb');
    if (!thumbs.length) return;
    var limit = imagesPerColour();
    var group = [];
    if (colour) {
      // Whole colour name first; only if nothing matches does the looser
      // single-word pass run, so "Navy" never steals "Navy Blue" photos from a
      // product that has both.
      group = thumbs.filter(function (t) {
        return mediaMatchesColour(t.dataset.colour, colour);
      });
      if (!group.length) {
        group = thumbs.filter(function (t) {
          return mediaMatchesColourWord(t.dataset.colour, colour);
        });
      }
    }
    // A colour with no identifiable images shows the whole gallery rather than
    // an empty strip.
    if (!group.length) group = thumbs;
    thumbs.forEach(function (t) {
      var i = group.indexOf(t);
      t.hidden = i === -1 || i >= limit;
    });
    syncSlidesToThumbs();
    var first = group[0];
    if (first) swapMain(first.dataset.src, first.dataset.alt, first.dataset.mediaId);
  }

  // "Product in Burgundy", when the Title block has the option enabled and the
  // title does not already name that colour.
  function updateTitleForColour(colour) {
    var h1 = $('.mypi-info__title');
    if (!h1 || !h1.dataset.colourInTitle) return;
    var base = h1.dataset.baseTitle || h1.textContent;
    if (!colour || colourKey(base).indexOf(colourKey(colour)) !== -1) {
      h1.textContent = base;
      return;
    }
    h1.textContent = base + ' in ' + colour;
  }

  // The colour lives in the hash — /products/x#burgundy — so the address bar never
  // grows a "?". Any option params from an older link are stripped; unrelated query
  // string (utm_*, click ids) is left alone.
  function writeColourUrl(colour) {
    var handle = colourToHandle(colour);
    var params = new URLSearchParams(window.location.search);
    ['variant', 'colour', 'color'].forEach(function (k) { params.delete(k); });
    $$('.mypi-product [data-option-position]').forEach(function (picker) {
      if (picker.dataset.optionName) params.delete(picker.dataset.optionName);
    });
    var query = params.toString();
    var url = window.location.pathname + (query ? '?' + query : '') + (handle ? '#' + handle : '');
    history.replaceState({}, '', url);
  }

  function onColourChosen(colour) {
    filterGalleryByColour(colour);
    updateTitleForColour(colour);
    writeColourUrl(colour);
    syncCombosToColour(colour);
  }

  // "Hot Pink" -> "pink". The family list is rendered by mypi-complete-look.liquid
  // (which uses it for the first paint); earlier families win.
  function colourFamily(colour) {
    var holder = $('[data-colour-families]');
    var text = ' ' + colourKey(colour).replace(/[^a-z0-9]+/g, ' ') + ' ';
    if (!holder || !text.trim()) return '';
    var families = holder.dataset.colourFamilies.split('|');
    for (var i = 0; i < families.length; i++) {
      var parts = families[i].split(':');
      var words = (parts[1] || '').split(',');
      for (var j = 0; j < words.length; j++) {
        if (text.indexOf(' ' + words[j] + ' ') !== -1) return parts[0];
      }
    }
    return '';
  }

  // Complete the Look follows the page: each combo switches to the chosen colour,
  // or failing that to one of the same family — ideally one named inside the
  // chosen colour ("Khaki Green" -> "Green"). A combo already on a fitting colour
  // is left alone, so a size or model picked there is not reset. With nothing
  // related in stock the combo goes back to its default (first) option.
  function syncCombosToColour(colour) {
    var wanted = colourKey(colour);
    if (!wanted) return;
    var family = colourFamily(colour);
    var wantedText = ' ' + wanted.replace(/[^a-z0-9]+/g, ' ') + ' ';
    function namedInWanted(c) {
      return wantedText.indexOf(' ' + colourKey(c).replace(/[^a-z0-9]+/g, ' ') + ' ') !== -1;
    }
    $$('.mypi-combo select').forEach(function (sel) {
      var current = sel.options[sel.selectedIndex];
      var currentColour = current ? current.dataset.colour : '';
      if (colourKey(currentColour) === wanted) return;
      var exact = -1, related = -1, named = -1;
      for (var i = 0; i < sel.options.length; i++) {
        var c = sel.options[i].dataset.colour;
        if (!c) continue;
        if (colourKey(c) === wanted) { exact = i; break; }
        if (!family || colourFamily(c) !== family) continue;
        if (related === -1) related = i;
        if (named === -1 && namedInWanted(c)) named = i;
      }
      var pick = exact;
      if (pick === -1) {
        if (related === -1) {
          // No colour option at all (say, sizes only): nothing to reset.
          if (!sel.querySelector('option[data-colour]') || sel.selectedIndex === 0) return;
          pick = 0;
        } else if (named !== -1) {
          if (namedInWanted(currentColour)) return;
          pick = named;
        } else {
          if (colourFamily(currentColour) === family) return;
          pick = related;
        }
      }
      sel.selectedIndex = pick;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // Only the thumbs on show — after colour filtering that is the current colour's
  // group, so swiping never wanders into another colour's photos.
  function visibleThumbs() {
    return $$('.mypi-thumb').filter(function (t) { return !t.hidden; });
  }

  function stepGallery(direction) {
    var thumbs = visibleThumbs();
    if (thumbs.length < 2) return;
    var current = -1;
    thumbs.forEach(function (t, i) {
      if (current === -1 && t.classList.contains('is-active')) current = i;
    });
    if (current === -1) current = 0;
    var next = (current + direction + thumbs.length) % thumbs.length;
    var t = thumbs[next];
    swapMain(t.dataset.src, t.dataset.alt, t.dataset.mediaId, true);
  }

  // Swiping is the track's native scroll-snap. This only keeps the active
  // thumb/dot in step with it (once per frame) and adds arrow-key stepping.
  var resizeBound = false;
  function initSwipe(main) {
    if (!main || main.__swipe) return;
    main.__swipe = true;

    var track = galleryTrack();
    if (track) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          markActive(currentSlideIndex());
        });
      }, { passive: true });
      // A finger on the image is the strongest hint a swipe is coming.
      track.addEventListener('touchstart', warmSlides, { passive: true, once: true });
      // Keep the current slide aligned if the width changes (rotation).
      // One module-level listener (bound once) re-reads the live track, so
      // Theme Editor re-inits don't stack listeners on stale tracks.
      track.__lastWidth = track.clientWidth;
      if (!resizeBound) {
        resizeBound = true;
        window.addEventListener('resize', function () {
          var t = galleryTrack();
          if (!t) return;
          var lastWidth = t.__lastWidth || t.clientWidth;
          if (t.clientWidth === lastWidth) return;
          var index = Math.round(t.scrollLeft / (lastWidth || 1));
          t.__lastWidth = t.clientWidth;
          goToSlide(index, false);
        });
      }
    }

    // Keyboard equivalent for anyone not using touch.
    main.setAttribute('tabindex', '0');
    main.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { stepGallery(1); e.preventDefault(); }
      else if (e.key === 'ArrowLeft') { stepGallery(-1); e.preventDefault(); }
    });
  }

  function initGallery() {
    var main = $('#galleryMain');
    if (!main) return;
    initSwipe(main);
    $$('.mypi-thumb').forEach(function (t) {
      if (t.__bound) return;
      t.__bound = true;
      t.addEventListener('click', function () {
        $$('.mypi-thumb').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        swapMain(t.dataset.src, t.dataset.alt, t.dataset.mediaId, true);
        main.classList.remove('is-zoomed');
      });
    });
    // Open on the server-chosen image (a ?variant= link may point past slide 1),
    // draw the dots, then fetch the rest of the group once the page has settled.
    var activeThumb = $('.mypi-thumb.is-active');
    if (activeThumb) goToMedia(activeThumb.dataset.mediaId, false);
    renderDots();
    if (document.readyState === 'complete') warmSlides();
    else window.addEventListener('load', warmSlides, { once: true });
    var zoom = $('#zoomBtn');
    if (zoom && !zoom.__bound) {
      zoom.__bound = true;
      zoom.addEventListener('click', function () {
        $('#galleryMain').classList.toggle('is-zoomed');
      });
    }
  }

  /* ---------- variant engine ---------- */
  function initVariants() {
    var jsonEl = document.querySelector('script[id^="mypiProductJSON-"]');
    var form = document.querySelector('form.js-mypi-product-form');
    if (!jsonEl || !form) return;

    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var optionCount = (data.options || []).length;
    var idInput = form.querySelector('input[name="id"]');

    var pickers = $$('.mypi-product [data-option-position]');
    if (!pickers.length) return; // Default Title product — nothing to drive

    function selectedOptions() {
      var sel = [];
      for (var i = 0; i < optionCount; i++) sel[i] = null;
      pickers.forEach(function (el) {
        var idx = parseInt(el.dataset.optionPosition, 10) - 1;
        if (el.tagName === 'SELECT') {
          sel[idx] = el.value || null; // '' is the gate's "Select …" placeholder
        } else {
          var active = $('.mypi-swatch.is-active', el);
          if (active) sel[idx] = active.dataset.colour;
        }
      });
      return sel;
    }

    // The no-preselect gate: a variant only resolves once EVERY option has
    // a chosen value — a partial selection must never match a variant.
    function findVariant(sel) {
      for (var j = 0; j < sel.length; j++) {
        if (sel[j] === null || sel[j] === undefined) return null;
      }
      for (var i = 0; i < variants.length; i++) {
        var match = true;
        for (var k = 0; k < sel.length; k++) {
          if (variants[i].options[k] !== sel[k]) { match = false; break; }
        }
        if (match) return variants[i];
      }
      return null;
    }

    // Out-of-stock labels. Each value is judged against the other options already
    // chosen: a colour is out of stock when every variant with that colour (and
    // the chosen model, once there is one) has no stock. A pairing Shopify has no
    // variant for at all reads "Unavailable" instead. Products set to keep
    // selling when out of stock count as available, so they are never labelled.
    var labelHolder = $('.mypi-product [data-label-soldout]');
    var soldOutText = (labelHolder && labelHolder.dataset.labelSoldout) || 'Out of stock';
    var unavailableText = (labelHolder && labelHolder.dataset.labelUnavailable) || 'Unavailable';

    function valueStatus(idx, value, sel) {
      var exists = false;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.options[idx] !== value) continue;
        var fits = true;
        for (var k = 0; k < sel.length; k++) {
          if (k !== idx && sel[k] !== null && v.options[k] !== sel[k]) { fits = false; break; }
        }
        if (!fits) continue;
        if (v.available) return '';
        exists = true;
      }
      return exists ? soldOutText : unavailableText;
    }

    function refreshStock() {
      var sel = selectedOptions();
      pickers.forEach(function (picker) {
        var idx = parseInt(picker.dataset.optionPosition, 10) - 1;
        if (picker.tagName === 'SELECT') {
          var selectedStatus = '';
          Array.prototype.forEach.call(picker.options, function (opt) {
            if (!opt.value) return; // the "Select …" placeholder
            var status = valueStatus(idx, opt.value, sel);
            opt.textContent = status ? opt.value + ' - ' + status : opt.value;
            opt.classList.toggle('is-soldout', !!status);
            if (opt.selected && status) selectedStatus = status;
          });
          picker.classList.toggle('is-soldout', !!selectedStatus);
          var optWrap = picker.closest('.mypi-opt');
          var optStock = optWrap ? optWrap.querySelector('.mypi-opt__stock') : null;
          if (optStock) {
            optStock.textContent = selectedStatus;
            optStock.hidden = !selectedStatus;
          }
        } else {
          $$('.mypi-swatch', picker).forEach(function (sw) {
            var name = sw.dataset.colour;
            var status = valueStatus(idx, name, sel);
            sw.dataset.stock = status;
            sw.classList.toggle('is-soldout', !!status);
            sw.setAttribute('aria-label', status ? name + ', ' + status : name);
            if (status) sw.title = name + ' - ' + status; else sw.removeAttribute('title');
          });
        }
      });
      var colourStock = $('#colourStock');
      if (colourStock) {
        var active = $('.mypi-product .mypi-swatch.is-active');
        var text = (active && active.dataset.stock) || '';
        colourStock.textContent = text;
        colourStock.hidden = !text;
      }
    }

    function buyButtons() {
      var btns = $$('.js-add-to-bag', form);
      $$('.js-add-to-bag[form="' + form.id + '"]').forEach(function (b) { btns.push(b); });
      return btns;
    }

    function syncSticky() {
      var stickyColour = $('#stickyColour');
      var activeSwatch = $('.mypi-product .mypi-swatch.is-active');
      if (stickyColour && activeSwatch) stickyColour.textContent = activeSwatch.dataset.colour;
      var stickyDevice = $('#stickyDevice');
      var firstSelect = $('.mypi-product select[data-option-position]');
      if (stickyDevice && firstSelect) stickyDevice.textContent = firstSelect.value;
      var sep = $('#stickySep');
      if (sep) {
        sep.hidden = !(stickyColour && stickyColour.textContent.trim() &&
          stickyDevice && stickyDevice.textContent.trim());
      }
    }

    function apply(variant) {
      var available = !!(variant && variant.available);

      refreshStock();
      var stockNote = $('#mainStockNote');
      if (stockNote) stockNote.hidden = !(variant && !available);

      if (idInput) idInput.value = variant ? variant.id : '';

      if (variant) {
        var price = $('#mainPrice');
        if (price) price.textContent = money(variant.price / 100);
        var stickyPrice = $('#stickyPrice');
        if (stickyPrice) stickyPrice.textContent = money(variant.price / 100);

        if (variant.featured_media && variant.featured_media.preview_image) {
          swapMain(variant.featured_media.preview_image.src, null, variant.featured_media.id);
        }
      }

      buyButtons().forEach(function (btn) {
        if (variant && !available) {
          // a real, resolved variant that's out of stock
          btn.disabled = true;
          btn.removeAttribute('data-gated');
          btn.setAttribute('aria-disabled', 'true');
          btn.textContent = (window.mypiStrings && window.mypiStrings.soldOut) || 'Sold Out';
        } else if (!variant) {
          // gated / incomplete selection — clickable so the form's notice
          // can explain, but marked held-back
          btn.disabled = false;
          btn.setAttribute('data-gated', '');
          btn.setAttribute('aria-disabled', 'true');
          btn.textContent = (window.mypiStrings && window.mypiStrings.addToBag) || 'Add to Bag';
        } else {
          btn.disabled = false;
          btn.removeAttribute('data-gated');
          btn.setAttribute('aria-disabled', 'false');
          btn.textContent = (window.mypiStrings && window.mypiStrings.addToBag) || 'Add to Bag';
        }
      });

      syncSticky();
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }));
    }

    $$('.mypi-product .mypi-swatch').forEach(function (s) {
      if (s.__bound) return;
      s.__bound = true;
      s.addEventListener('click', function () {
        var group = s.closest('.mypi-swatches');
        $$('.mypi-swatch', group).forEach(function (x) {
          x.classList.remove('is-active');
          x.setAttribute('aria-checked', 'false');
        });
        s.classList.add('is-active');
        s.setAttribute('aria-checked', 'true');
        var name = $('#colourName');
        if (name) name.textContent = s.dataset.colour;
        apply(findVariant(selectedOptions()));
        onColourChosen(s.dataset.colour);
      });
    });

    $$('.mypi-product select[data-option-position]').forEach(function (sel) {
      if (sel.__bound) return;
      sel.__bound = true;
      sel.addEventListener('change', function () {
        apply(findVariant(selectedOptions()));
      });
    });

    // Arriving from a collection variant card. The colour rides in the hash so the
    // URL carries no "?":
    //   /products/luggage-tag#coral                      (bare colour)
    //   /products/gift-set#colour=Brown&device=iPhone+17+Pro   (several options)
    // Query params in the same key=value form are still honoured, so older links
    // and shared ?colour= URLs keep working.
    //
    // Only the options named in the URL are applied — anything left out stays
    // unchosen, so findVariant() returns null and the no-preselect gate holds
    // until the customer finishes choosing.
    (function applyOptionsFromUrl() {
      var hash = (window.location.hash || '').replace(/^#/, '');
      var bareColour = '';
      var params;

      if (hash && hash.indexOf('=') === -1) {
        bareColour = decodeURIComponent(hash);        // "#coral"
        params = new URLSearchParams(window.location.search);
      } else if (hash) {
        params = new URLSearchParams(hash);           // "#colour=Brown&device=..."
      } else {
        params = new URLSearchParams(window.location.search);
      }
      if (!bareColour && !params.toString()) return;

      var touchedSelect = false;
      var chosenColour = '';

      pickers.forEach(function (picker) {
        var key = picker.dataset.optionName;
        var value = key ? params.get(key) : null;
        var isSwatchGroup = !!picker.querySelector('.mypi-swatch');
        // Spelling fallback: a swatch group answers to a bare "#coral" and to
        // colour/color even if the option is named "Leather Colour".
        if (value === null && isSwatchGroup) {
          value = bareColour || params.get('colour') || params.get('color');
        }
        if (value === null || value === '') return;
        // Compared as handles, so "#hot-pink" finds the value "Hot Pink".
        var wanted = colourToHandle(value);

        if (picker.tagName === 'SELECT') {
          for (var i = 0; i < picker.options.length; i++) {
            var opt = picker.options[i];
            if (opt.value && colourToHandle(opt.value) === wanted) {
              picker.value = opt.value;
              touchedSelect = true;
              break;
            }
          }
        } else {
          var match = null;
          $$('.mypi-swatch', picker).forEach(function (sw) {
            if (match) return;
            if (colourToHandle(sw.dataset.colour) === wanted) match = sw;
          });
          // click() reuses the normal selection path (active state, colour label,
          // sticky bar) rather than duplicating it here — including the gallery
          // group, title and URL via onColourChosen().
          if (match) {
            chosenColour = match.dataset.colour || '';
            if (!match.classList.contains('is-active')) match.click();
          }
        }
      });
      if (touchedSelect) apply(findVariant(selectedOptions()));
      // A swatch already active on load fires no click, so settle the gallery,
      // title and URL here.
      if (chosenColour) onColourChosen(chosenColour);
    })();

    refreshStock();
  }

  /* ---------- sticky bar (reference logic) ---------- */
  function toggleSticky() {
    var stickyBar = $('#stickyBar'), infoCta = $('.mypi-cta');
    if (!stickyBar || !infoCta) return;
    var r = infoCta.getBoundingClientRect();
    var show = r.bottom < 0 || r.top > window.innerHeight;
    stickyBar.classList.toggle('is-visible', show);
    stickyBar.setAttribute('aria-hidden', !show);
    stickyBar.inert = !show;
  }
  window.addEventListener('scroll', toggleSticky, { passive: true });
  window.addEventListener('resize', toggleSticky);

  /* ---------- complete-look: select drives the add button ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest ? e.target.closest('.mypi-combo select') : null;
    if (!sel) return;
    var combo = sel.closest('.mypi-combo');
    if (!combo) return;
    var opt = sel.options[sel.selectedIndex];
    if (sel.hasAttribute('data-combo-colour-link')) {
      // Personalised product: the colour rides to its own page in the hash.
      var link = combo.querySelector('a[data-base-url]');
      if (link) {
        link.href = link.dataset.baseUrl +
          (sel.value ? '#' + sel.dataset.comboColourLink + '=' + encodeURIComponent(sel.value) : '');
      }
    } else {
      var btn = combo.querySelector('.js-add-to-bag');
      if (btn) btn.dataset.variantId = sel.value;
    }
    var img = combo.querySelector('.mypi-combo__img img');
    if (img && opt && opt.dataset.image) {
      img.removeAttribute('srcset');
      img.src = opt.dataset.image;
    }
  });

  /* ---------- recommendations (You May Also Like) ---------- */
  function initRecommendations() {
    var el = document.querySelector('[data-recommendations][data-url]');
    if (!el) return;
    var url = el.dataset.url;
    el.removeAttribute('data-url');
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (!fresh) return;
        el.innerHTML = fresh.innerHTML;
        if (fresh.hasAttribute('hidden')) el.setAttribute('hidden', '');
      })
      .catch(function () {});
  }

  /* ---------- init + Theme Editor support ---------- */
  function init() {
    // Gated buttons are server-rendered with a real `disabled` so a no-JS
    // submit can never post an empty variant id. With JS running, restore
    // the clickable aria-disabled gate so the form's notice can explain.
    $$('.js-add-to-bag[data-gated]').forEach(function (btn) { btn.disabled = false; });
    initGallery();
    initVariants();
    initRecommendations();
    toggleSticky();
  }
  init();
  document.addEventListener('shopify:section:load', function (e) {
    // Only re-init when the reloaded section is (or contains) the product UI.
    var t = e.target;
    if (!t || !t.querySelector) return;
    if (t.matches('.mypi-product, #galleryMain, [data-recommendations]') ||
        t.querySelector('.mypi-product, #galleryMain, [data-recommendations]')) init();
  });
})();
